import draftToHtml from "draftjs-to-html";
import {safeURL} from "./formatter";

export function saveRichText(data) {
    return draftToHtml(JSON.parse(data), null, false, (entity, text) => {
        if (entity.type === 'LINK') {
            return `<a href="${safeURL(entity.data.url)}" target="_blank" rel="noopener noreferrer">${text}</a>`;
        }
        return text;
    });
}